<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="dictionaryList">
      <div slot="btn-box" style="text-align: right;padding: 0 10px 10px;float: right;">
        <el-button id="dictionaryId" type="primary" size="small" @click="handleAdd()">新增权限</el-button>
      </div>
      <div slot="content" class="table-content">
        <el-table :data="tableDatas" style="width: 100%" height="100%" v-loading="loading" border>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="roleName" label="角色名称"></el-table-column>
          <el-table-column prop="roleDes" label="角色描述"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button :id="scope.row.roleId+'_edit'" @click="handleEdit(scope.$index, scope.row)" type="primary" size="small">编辑</el-button>
              <el-button :id="scope.row.roleId+'_delete'" @click="handleDelete(scope.$index, scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    <!--添加-->
    <el-dialog title="添加" :close-on-click-modal="false" :visible.sync="dialogAddFormVisible" @close="resetForm('ruleForm')">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="角色名称" prop="roleName">
          <el-input id="ruleFormRoleName" v-model="ruleForm.roleName"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="roleDes" >
          <el-input id="ruleFormTextarea" type="textarea" v-model="ruleForm.roleDes"  maxlength="100" placeholder="100字以内"></el-input>
        </el-form-item>
        <el-form-item label="pc端菜单">
          <el-checkbox-group v-model="ruleForm.menuIds" id="ruleFormCheckbox">
            <!--
            <el-checkbox v-for="(item, index) in menuList" :key="item.menuId" v-if="item.menuType=='web'" :label="item.menuId" name="menuIds">{{item.menuName}}</el-checkbox>
            -->
            <div v-for="(item, index) in menuList" >
              <el-checkbox class="pc_menu pc_second_menu" :key="item.menuId" v-if="item.menuType=='web'" :label="item.menuId" name="menuIds">
                <div>{{item.menuName}}</div>
              </el-checkbox>
<!--              <el-checkbox v-for="(twoMenu,index) in item.sysMenuList" :key="twoMenu.menuId" v-if="twoMenu.menuType=='web'" :label="twoMenu.menuId">
                <span>{{twoMenu.menuName}}</span>
              </el-checkbox>-->
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="移动端菜单">
          <el-checkbox-group v-model="ruleForm.menuIds" id="ruleFormCheckboxWeb">
            <!--
            <el-checkbox v-for="(item, index) in menuList" :key="item.menuId" v-if="item.menuType!='web'" :label="item.menuId" name="menuIds">{{item.menuName}}</el-checkbox>
            -->
            <div v-for="(item, index) in menuList">
              <el-checkbox  class="pc_menu pc_second_menu" :key="item.menuId" v-if="item.menuType!='web'" :label="item.menuId" name="menuIds">
                <div>{{item.menuName}}</div>
              </el-checkbox>
              <el-checkbox v-for="(twoMenu,index) in item.sysMenuList" :key="twoMenu.menuId" v-if="twoMenu.menuType!='web'" :label="twoMenu.menuId">
                <span>{{twoMenu.menuName}}</span>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button id="submitFormId" type="primary" @click="submitForm('ruleForm','add')">添加</el-button>
          <el-button id="submitFormReset" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--编辑-->
    <el-dialog title="修改信息" :close-on-click-modal="false" :visible.sync="dialogFormVisible" @close="refresh">
      <el-form :model="editRuleForm" :rules="rules" ref="editRuleForm" label-width="100px" >
        <el-form-item label="角色名称" prop="roleName" >
          <el-input id="editRuleFormRoleName" v-model="editRuleForm.roleName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="roleDes" >
          <el-input id="editRuleFormTextarea" type="textarea" v-model="editRuleForm.roleDes"  maxlength="100" placeholder="100字以内"></el-input>
        </el-form-item>
        <el-form-item label="pc端菜单">
          <el-checkbox-group v-model="editRuleForm.menuIds" id="editRuleFormMenuType">
            <div v-for="(item, index) in menuList" >
              <el-checkbox class="pc_menu pc_second_menu" :key="item.menuId" v-if="item.menuType=='web'" :label="item.menuId" name="menuIds">
                <div>{{item.menuName}}</div>
              </el-checkbox>
              <el-checkbox v-for="(twoMenu,index) in item.sysMenuList" :key="twoMenu.menuId" v-if="twoMenu.menuType=='web'" :label="twoMenu.menuId">
                <span>{{twoMenu.menuName}}</span>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="移动端菜单">
          <el-checkbox-group v-model="editRuleForm.menuIds" id="editRuleFormMenuTypeWeb">
            <div v-for="(item, index) in menuList">
              <el-checkbox  class="pc_menu pc_second_menu" :key="item.menuId" v-if="item.menuType!='web'" :label="item.menuId" name="menuIds">
                <div>{{item.menuName}}</div>
              </el-checkbox>
              <el-checkbox v-for="(twoMenu,index) in item.sysMenuList" :key="twoMenu.menuId" v-if="twoMenu.menuType!='web'" :label="twoMenu.menuId">
                <span>{{twoMenu.menuName}}</span>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button id="submitFormDialogFormVisible" @click="dialogFormVisible = false">取 消</el-button>
        <el-button id="submitFormPrimary" type="primary" @click="submitForm('editRuleForm','update')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'dictionaryList',
  data () {
    return {
      tableDatas: [],
      selectTable: {},
      dialogFormVisible: false,
      dialogTableVisible: false,
      dialogAddFormVisible: false,
      menuList:[],   //菜单List
      loading:true,
      ruleForm: {
        roleName: '',
        menuIds:[],
        menuNames:[],
        roleDes:''
      },
      editRuleForm: {
        roleId:null,
        roleName: '',
        menuIds:[],
        menuNames:[],
        roleDes:''
      },
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { max: 20, message: '20 个字符以内', trigger: 'blur' }
        ],
        roleDes: [
          {  max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  components:{
  },
  props: {},
  created() {
  },
  mounted() {
    this.queryRoleList();
  },
  methods: {
    //字典组列表
    queryRoleList() {
      var _this = this;
      _this.$post('sys/findSysRoleList').then(function(response){
        if (response.code == '1'){
          _this.loading = false;
          _this.tableDatas = response.result.sysRoleList;
        }
      }).catch(function (error) {

      })
    },
    //增加弹窗
    handleAdd: function () {
      var _this = this;
      _this.$post('sys/findSysMenuList',{isPublic:0}).then(function(response){
        if (response.code == '1'){
          _this.menuList = response.result.sysMenuList;
        }
      }).catch(function (error) {

      })

      this.dialogAddFormVisible = true;
    },
    //验证表单
    submitForm(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(type === 'update'){
            this.updateRole();
          }else if(type === 'add'){
            this.addRole();
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.refresh();
    },
    //请求后台增加
    addRole:function () {
      var _this = this;
      //获取菜单名称
      for(var i=0;i<this.menuList.length;i++){
        if(_this.ruleForm.menuIds.indexOf(this.menuList[i].menuId)!=-1){
          _this.ruleForm.menuNames.push(this.menuList[i].menuName);
        }
      }
      if(this.isEmojiCharacter(_this.ruleForm.roleName)){
        _this.$message({
          type: '填写角色名称不能包含表情',
          message: response.msg
        });
        return;
      }
      if(this.isEmojiCharacter(_this.ruleForm.roleDes)){
        _this.$message({
          type: '填写角色描述不能包含表情',
          message: response.msg
        });
        return;
      }
      _this.$post('sys/addSysRole',{
        roleName: _this.ruleForm.roleName,
        menuNames: _this.ruleForm.menuNames.toString(),
        menuIds: _this.ruleForm.menuIds.toString(),
        roleDes: _this.ruleForm.roleDes
      }).then(function (response) {
        if (response.code == '1') {
          _this.dialogAddFormVisible = false;
          _this.$message({
            type: 'success',
            message:  '添加权限成功'
          });
          _this.ruleForm.menuIds = [];
          _this.queryRoleList();
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {

      })
    },
    //删除
    handleDelete(index, row) {
      this.$confirm('是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this;
        _this.$post('sys/deleteSysRole',{
          roleId: row.roleId
        }).then(function(response){
          if (response.code == '1') {
            _this.$message({
              type: 'success',
              showClose: true,
              message: '删除成功!'
            });
            _this.queryRoleList();
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //编辑窗口
    handleEdit(index, row) {
      var _this = this;//findSysMenuList
      _this.$post('sys/findAllSysMenuList',{isPublic:0}).then(function(response){
        if (response.code == '1'){
//	      	_this.menuList = response.data.result.sysMenuList;
          _this.menuList = response.result.SysMenuListDtoList;
        }
      }).catch(function (error) {

      })
      this.editRuleForm.roleId = row.roleId;
      this.editRuleForm.roleName = row.roleName;
      this.editRuleForm.roleDes = row.roleDes;
      this.editRuleForm.menuIds=[];
      this.editRuleForm.menuNames=[];
      if(row.menuIds != null && row.menuIds != ""){
        var menuIdArr = row.menuIds.split(",");
        for(var i=0;i<menuIdArr.length;i++){
          this.editRuleForm.menuIds.push(parseInt(menuIdArr[i]));
        }
      }
      this.dialogFormVisible = true;
    },
    //更新
    updateRole(){
      this.dialogFormVisible = false;
      var _this = this;
      if(this.isEmojiCharacter(_this.ruleForm.roleName)){
        _this.$message({
          type: '填写角色名称不能包含表情',
          message: response.msg
        });
        return;
      }
      if(this.isEmojiCharacter(_this.ruleForm.roleDes)){
        _this.$message({
          type: '填写角色描述不能包含表情',
          message: response.msg
        });
        return;
      }
      //获取菜单名称
      for(var i=0;i<_this.menuList.length;i++){
        if(_this.editRuleForm.menuIds.indexOf(_this.menuList[i].menuId)!=-1){
          _this.editRuleForm.menuNames.push(_this.menuList[i].menuName);
        }
        /*var sysMenuList = _this.menuList[i].sysMenuList;
        if(sysMenuList !=''){
          for(var i=0;i<sysMenuList.length;i++){
            if(_this.editRuleForm.menuIds.indexOf(sysMenuList[i].menuId)!=-1){
              _this.editRuleForm.menuNames.push(sysMenuList[i].menuName);
            }
          }
        }*/

      }
      console.log(this.editRuleForm.menuIds);
      _this.$post('sys/editSysRole',{
        roleId: _this.editRuleForm.roleId,
        roleName: _this.editRuleForm.roleName,
        menuNames: _this.editRuleForm.menuNames.toString(),
        menuIds: _this.editRuleForm.menuIds.toString(),
        roleDes: _this.editRuleForm.roleDes
      }).then(function (response) {
        if (response.code == '1') {
          _this.$message({
            type: 'success',
            message: '更新信息成功'
          });
          _this.queryRoleList();
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {

      })
    },
    //编辑框关闭跳转
    refresh(){
      this.queryRoleList();
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style lang="scss" scoped>
.pc_menu {
  display: block;
}
.pc_menu.el-checkbox+.el-checkbox {
  margin-left: 0;
}
.pc_second_menu.el-checkbox+.el-checkbox {
  margin-left: 30px;
}
</style>-->
<style lang="less">
	.dictionaryList{
		height: 100%;
	}
	.table-content{
		height: calc(100% - 50px);
	}
</style>
